import { sdk } from 'sdk';

export interface UserConfig {
  enableResetPassword?: boolean;
  [key: string]: unknown;
}

export const DEFAULT_USER_CONFIG: UserConfig = {};

export const loadUserConfig = async (): Promise<UserConfig> => {
  try {
    const response = await sdk.callAction({
      actionName: 'user-config/getUserConfig',
    });
    if (!response.isError) {
      return response.data as UserConfig;
    }
  } catch (error) {
    console.error('loadUserConfig - Failed to fetch user config:', error);
  }

  return DEFAULT_USER_CONFIG;
};
